import React, { useState } from "react";
import theme from "../../../styles/theme";

/* ============================================================================
   TOKENS
============================================================================ */

const T = {
  text: theme?.colors?.text?.primary || "#164D63",
  soft: theme?.colors?.text?.small || "#5C7A89",
  verySoft: theme?.colors?.text?.verysmall || "#7D97A1",

  green: "#1A8C74",
  orange: "#B8621B",
  red: "#C24C2C",
};

/* ============================================================================
   MOCK DATA
============================================================================ */

const selectedPackage = {
  name: "Bloc traitement – ligne 1",
  status: "À surveiller",
  role: "Nœud critique",
  dependencies: 2,
  criticality: "Critique",
  zone: "Process",
};

const issues = [
  "Dépendance manquante",
  "Charge élevée",
];

/* ============================================================================
   UI
============================================================================ */

const SectionTitle = ({ children }) => (
  <div
    style={{
      fontSize: "0.72rem",
      color: T.verySoft,
      textTransform: "uppercase",
      marginBottom: 6,
    }}
  >
    {children}
  </div>
);

const Row = ({ label, value }) => (
  <div style={{ display: "flex", justifyContent: "space-between" }}>
    <span style={{ fontSize: "0.72rem", color: T.soft }}>{label}</span>
    <span style={{ fontSize: "0.72rem", color: T.text }}>{value}</span>
  </div>
);

/* ============================================================================
   MAIN
============================================================================ */

const ActivityReviewPanel = () => {
  const [status, setStatus] = useState("Draft");

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      {/* Package */}
      <div>
        <SectionTitle>Package</SectionTitle>
        <div style={{ fontSize: "0.82rem", color: T.text }}>
          {selectedPackage.name}
        </div>
        <div style={{ fontSize: "0.72rem", color: T.soft }}>
          {selectedPackage.status} · {selectedPackage.role}
        </div>
      </div>

      {/* Infos */}
      <div>
        <SectionTitle>Infos</SectionTitle>
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <Row label="Dépendances" value={selectedPackage.dependencies} />
          <Row label="Criticité" value={selectedPackage.criticality} />
          <Row label="Zone" value={selectedPackage.zone} />
        </div>
      </div>

      {/* Issues */}
      <div>
        <SectionTitle>Issues</SectionTitle>
        <div style={{ fontSize: "0.75rem", color: T.orange }}>
          {issues.map((i, idx) => (
            <div key={idx}>• {i}</div>
          ))}
        </div>
      </div>

      {/* Actions */}
      <div>
        <SectionTitle>Actions</SectionTitle>
        <div style={{ display: "flex", gap: 8 }}>
          <button>Corriger</button>
          <button>Revoir Structuring</button>
          <button>Revoir Sequencing</button>
        </div>
      </div>

      {/* Validation */}
      <div>
        <SectionTitle>Validation</SectionTitle>

        <select
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          style={{ marginBottom: 8 }}
        >
          <option>Draft</option>
          <option>Reviewed</option>
          <option>Ready</option>
        </select>

        <button
          style={{
            background: T.green,
            color: "#fff",
            padding: "6px 12px",
            border: "none",
            borderRadius: 4,
          }}
        >
          Valider Activity
        </button>
      </div>
    </div>
  );
};

export default ActivityReviewPanel;